<template>
  <div>
    <modelCheckTree
      :currentNodeItemF="currentSelectedModelItem"
      :multiSelectedItems="multiSelectedItems"
      @setCheckedNode="getCheckedNode"
      :multiple="false"
      @multiItems="multiSelected"
    ></modelCheckTree>
    <div class="h-100 position-absolute" id="transparency" v-drag>
      <el-row class="table-header m-t-10">
        <el-col :span="12">
          <span>模型透明度</span>
        </el-col>
        <el-col :span="12" class="tr"> </el-col>
      </el-row>
      <div class="m-t-20">
        <el-slider
          v-model="transparencyValue"
          :min="0"
          :max="255"
          show-input
          @input="settingTransparency"
        ></el-slider>
        <div class="m-t-20 tr">
          <el-button size="mini" @click="resetTransparency">重 置</el-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import modelCheckTree from './modelCheckTree'

export default {
  components: { modelCheckTree },
  props: {
    defaultCheckedKey: {
      type: Array,
      default: () => {
        return []
      },
    },
    currentCode: {
      type: String,
      default: '',
    },
    currentModelItem: {
      type: Number,
      defalut: 0,
    },
    currentPlayerId: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      transparencyValue: 255, // 透明度值
      sliderTimerOut: null, // 滑动防抖
      currentSelectedModelItem: 0, // 当前点击模型节点
      isMultiSelected: false,
      multiSelectedItems: [],
      selectModelItem: [], // 模型选择树选中节点
    }
  },
  computed: {},
  watch: {
    currentModelItem(val) {
      if (val) {
        this.$nextTick(async () => {
          if (this.isMultiSelected) {
            this.multiSelectedItems = await window.player.Native.ModelTree.getMultiSelectedItems()
          }
          this.currentSelectedModelItem = val
        })
      }
    },
  },
  beforeDestroy() {
    if (!_.isEmpty(this.selectModelItem)) {
      window.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
    }
  },
  methods: {
    // 获取模型选中节点
    async getCheckedNode(data) {
      if (!_.isEmpty(this.selectModelItem)) {
        window.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
      }
      this.selectModelItem = _.map(data, 'item')
      this.transparencyValue = await window.player.Native.ModelTree.getItemAlpha(data[0].item)
      if (this.isMultiSelected) {
        window.player.Native.ModelTree.setSelectItemNoEvent(0)
      }
    },
    // 选择模式切换
    async multiSelected(bool) {
      this.isMultiSelected = bool
      const toolName = bool ? 'system.ToolMultiSelect' : 'system.Pickup'
      window.player.Native.Tools.setCurrentTool(toolName)
      if (!_.isEmpty(this.selectModelItem)) {
        window.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
        this.transparencyValue = 255
      }
    },
    // 设置模型透明度
    async settingTransparency() {
      if (this.sliderTimerOut) clearTimeout(this.sliderTimerOut)
      this.sliderTimerOut = setTimeout(async () => {
        window.player.Native.ModelTree.setSelectItemNoEvent(0)
        if (!_.isEmpty(this.selectModelItem)) {
          window.player.Native.ModelTree.setItemAlpha(
            this.selectModelItem[0],
            this.transparencyValue
          )
        }
        // const root = await window.player.Native.ModelTree.getRootItems()
        // const rootItems = _.map(root, 'item')
        // window.player.Native.ModelTree.setItemColor(rootItems, Number(`0xffffff${hex.join('')}`))
      }, 100)
    },
    // 重置模型透明度
    async resetTransparency() {
      window.player.Native.ModelTree.recoverItemAlpha(this.selectModelItem[0])
      this.transparencyValue = await window.player.Native.ModelTree.getItemAlpha(
        this.selectModelItem[0]
      )
    },
  },
  directives: {
    drag: {
      // 指令的定义
      bind(el) {
        const odiv = el // 获取当前元素
        el.onmousedown = (e) => {
          if (e.button === 0) {
            // 阻止穿透
            e.stopPropagation()
            // 算出鼠标相对元素的位置
            if (e.target.className === 'el-tooltip el-slider__button hover dragging') {
              return
            }
            const disX = e.clientX - odiv.offsetLeft
            const disY = e.clientY - odiv.offsetTop
            let left = ''
            let top = ''
            document.onmousemove = (e) => {
              // 阻止穿透
              e.stopPropagation()
              // 用鼠标的位置减去鼠标相对元素的位置，得到元素的位置
              left = e.clientX - disX
              top = e.clientY - disY
              // 绑定元素位置到positionX和positionY上面
              // 移动当前元素
              if (left < 0) {
                left = 0
              } else if (
                left >
                document.documentElement.clientWidth - odiv.offsetWidth - odiv.offsetWidth / 3
              ) {
                left =
                  document.documentElement.clientWidth - odiv.offsetWidth - odiv.offsetWidth / 3
              }
              if (top < 45) {
                top = 45
              } else if (top > document.documentElement.clientHeight - odiv.offsetHeight - 90) {
                top = document.documentElement.clientHeight - odiv.offsetHeight - 90
              }
              odiv.style.left = `${left}px`
              odiv.style.top = `${top}px`
            }
          }
          document.onmouseup = (e) => {
            document.onmousemove = null
            document.onmouseup = null
            document.onmouseout = null
          }
          return false
        }
      },
    },
  },
}
</script>
<style lang="scss" scoped>

#transparency {
  height: 180px;
  width: 400px;
  right: 8px;
  top: 46px;
  background-color: rgba(255, 255, 255, 0.76);
  border-radius: 4px;
  z-index: 99;
  padding: 0 20px 0 20px;
}
/deep/ .el-slider__runway,
/deep/ .el-slider__bar {
  height: 16px !important;
}
/deep/ .el-slider__button-wrapper {
  top: -10px !important;
}
/deep/ .el-slider__bar {
  background: transparent !important;
}
/deep/ .el-slider__runway {
  margin-right: 145px !important;
  background: linear-gradient(to right, rgba(180, 180, 180, 0) 0%, rgb(180, 180, 180) 100%),
    url('/static/img/bc/transparency.png') !important;
}
/deep/ .el-slider__input {
  width: 120px !important;
  margin-top: 7px !important;
}
/deep/ .el-slider__button {
  height: 20px !important;
  border-radius: 40% !important;
}

</style>
